<template>
    <template-layout>
        <template slot="header">
            <h1 class="title">Pedidos</h1>
        </template>

        <template slot="content">
            <section class="container" v-if="orders">
                <orders-order-view class="box"
                                   v-for="order in orders"
                                   :key="order.id"
                                   :order="order">
                </orders-order-view>
            </section>
        </template>
    </template-layout>
</template>

<script>
    import TemplateLayout from '../layout/TemplateLayout.vue';
    import OrdersOrderView from '../components/orders/OrderView';

    export default {
        name: 'orders',
        data() {
            return {
            }
        },

        components: {
            OrdersOrderView,
            TemplateLayout
        },

        computed: {
            customer() {
                return this.$store.getters['customer/get']();
            },

            orders() {
                return this.$store.getters['orders/getAll']();
            }
        },

        watch: {
            customer: {
                handler() {
                    this.$store.dispatch('orders/fetchAll', this.customer.id);
                },
                immediate: true            
            }
        },

        methods: {}
    }
</script>

<style lang="scss" scoped>

</style>